import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AccountRequests} from "../../../account/services/account-requests.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {PricePlanAlertsService} from "../../services/price-plan-alerts.service";
import {PricePlanBundleRequestsService} from "../../services/price-plan-bundle-requests.service";
import {PricePlanDialogService} from "../../services/price-plan-dialog-service.service";

export class AccountPricePlanDetailsComponent implements IController {
  accountId: any;
  pricePlanBundle: any;
  programTypes: any;
  selectedProgramId: any;

  enabledPrograms: any = {};
  public currentNavItem: any;


  constructor(private $log, private bringozLoaderService: BringozLoaderService, private $state,
              private pricePlanDialogService: PricePlanDialogService, private pricePlanBundleRequestsService: PricePlanBundleRequestsService,
              private accountRequests: AccountRequests, private pricePlanAlertsService: PricePlanAlertsService) {
  }

  $onInit() {
    this.currentNavItem = this.$state.current.name;
    this.enabledPrograms = this.getProgramMenu(this.pricePlanBundle.entryList, this.selectedProgramId);
  }

  onEditProgramTypes(event) {
    this.pricePlanDialogService.editProgram(event, this.pricePlanBundle, true)
      .then((updatedBundle) => {
        this.updatePricePlanBundle(updatedBundle);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onChangeProgram(event) {
    this.pricePlanDialogService.changeProgram(event, this.pricePlanBundle)
      .then((editedProgram) => {
        this.changeAccountProgram(editedProgram);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  changeState(stateName) {
    this.$state.go('^.' + stateName, {}, {notify: true, reload: false});
  }

  onProgramTypeChange(selectedProgramTypeId) {
    this.$state.transitionTo('.', {programId: selectedProgramTypeId}, {
      location: false,
      inherit: true,
      relative: this.$state.$current,
      notify: true
    })
  }

  // ******************************
  //        Private methods
  // ******************************

  private getProgramMenu(programs, selectedProgramId) {
    const enabledPrograms = _.filter(programs, (program) => {
      return program.enabled;
    });

    return _.map(enabledPrograms, (p) => {
      return {
        name: p.name,
        type: p.type,
        id: p.id,
        open: p.id === selectedProgramId
      }
    });
  }

  private updatePricePlanBundle(updatedBundle) {
    this.bringozLoaderService.on();
    this.pricePlanBundleRequestsService.editBundle(this.pricePlanBundle.id, updatedBundle, this.accountId)
      .then((updatedPricePlanBundle) => {
        this.pricePlanAlertsService.updateSuccess();

        this.pricePlanBundle = updatedPricePlanBundle;
        this.programTypes = _.filter(updatedPricePlanBundle.entryList, (programType) => {
          return programType.enabled;
        });

        const selectedProgramType = _.find(this.programTypes, (programType) => {
          return programType.id === this.selectedProgramId;
        });

        if (!selectedProgramType) {
          this.onProgramTypeChange(selectedProgramType.id);
        }
      })
      .catch(() => {
        this.pricePlanAlertsService.updateError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  private changeAccountProgram(program) {
    this.bringozLoaderService.on();
    this.accountRequests.setAccountPricePlanBundle(this.accountId, program.id)
      .then(() => {
        this.pricePlanBundle = program;
        this.programTypes = program.entryList || [];
        const selectedProgram = _.find(program.entryList, (programType) => {
          return programType.enabled
        });
        this.selectedProgramId = _.get(selectedProgram, 'id');
      })
      .catch(() => {
        this.pricePlanAlertsService.updateError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .component('accountPricePlanDetailsView', {
    bindings: {
      accountId: '<',
      pricePlanBundle: '<',
      programTypes: '<',
      selectedProgramId: '<'
    },
    template: require('./account-price-plan-details.html').default,
    controller: AccountPricePlanDetailsComponent
  });
